import React from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";

const SidebarItem = ({
  icon,
  label,
  isExpanded,
  hasDropdown = false,
  isOpen = false,
  toggleOpen = () => {},
  childrenData = [],
  href,
  currentPath,
  setIsSidebarExpanded,
}) => {
  const isActiveChild = childrenData.some(
    (child) => child.href === currentPath
  );
  const isActive = currentPath === href;
  const isHighlighted = isActive || isActiveChild;

  const navigate = useNavigate();

  return (
    <div>
      {!hasDropdown ? (
        <Link to={href}>
          <div
            className={`flex items-center justify-center cursor-pointer px-4 py-2 hover:bg-gray-100 transition-all ${
              isHighlighted ? "bg-blue-50 text-blue-600 rounded" : " text-black"
            }`}
          >
            <div className="text-xl">{icon}</div>
            {isExpanded && <span className="ml-3 text-lg flex-1">{label}</span>}
          </div>
        </Link>
      ) : (
        <div
          onClick={() => {
            setIsSidebarExpanded(true);
            toggleOpen();
            navigate("/vendorportal/jobs/ongoing");
          }}
          className={`flex items-center justify-center cursor-pointer px-4 py-2 hover:bg-gray-100 transition-all ${
            isHighlighted ? "bg-blue-50 text-blue-600 rounded" : "text-black"
          }`}
        >
          <div className="text-lg">{icon}</div>
          {isExpanded && (
            <>
              <span className="ml-3 flex-1 text-xl">{label}</span>
              <ExpandMoreIcon
                className={`transition-transform transform duration-300 ${
                  isOpen ? "rotate-180 " : "rotate-0"
                }`}
              />
            </>
          )}
        </div>
      )}

      {hasDropdown && isOpen && isExpanded && (
        <div className="ml-10 text-gray-500 space-y-2 text-sm px-4">
          {childrenData.map((child) => (
            <Link to={child.href} key={child.label}>
              <div
                className={`cursor-pointer text-base hover:bg-blue-50 ${
                  currentPath === child.href
                    ? "text-blue-600 font-semibold"
                    : " text-black"
                }`}
              >
                {child.label}
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
};

export default SidebarItem;
